import React from 'react';
import PropTypes from 'prop-types';
import { Field, useFormikContext } from 'formik';
import { Button } from 'primereact/button';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { renderAsyncSelector } from '../../../../components/formik-components/FormAsyncSelector';
import FormLanguageSelector from '../../../../components/formik-components/FormLanguageSelector';
import { formikFormShape } from '../../../../components/prop-types';

const messages = defineMessages({
  searchingLabel: {
    id: 'actions.select',
    defaultMessage: '- Select -',
  },
  submit: {
    id: 'assessment.matchingResults',
    defaultMessage: 'Matching Results',
  },
});

const StandardJobMatchForm = ({
  jobProfiles,
  jobSearching,
  searchJob,
  selectJob,
  languageList,
  selectLocale,
  readyToSubmit,
}) => {
  const { formatMessage } = useIntl();
  const { setFieldValue, isSubmitting } = useFormikContext();

  const searchingLabel = formatMessage(messages.searchingLabel);
  const submitLabel = formatMessage(messages.submit);
  return (
    <>
      <div className="p-grid">
        <div className="p-col">
          <FormattedMessage tagName="label" id="assessment.jobMatching" defaultMessage="Job Matching" />
          <Field
            component={renderAsyncSelector}
            data={jobProfiles}
            processing={jobSearching}
            textField="name"
            placeholder={searchingLabel}
            valueField="id"
            filter
            name="standardJobId"
            onSearch={searchJob}
            setFieldValue={(field, selectedJob) => {
              setFieldValue(field, selectedJob.id);
              selectJob(selectedJob.id);
            }}
          />
        </div>
      </div>
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <FormattedMessage id="attrs.locale" defaultMessage="Preferred Language" tagName="label" />
          <Field
            id="locale"
            name="locale"
            component={FormLanguageSelector}
            options={languageList}
            onChange={(event) => {
              setFieldValue('locale', event.value);
              selectLocale(event.value);
            }}
          />
        </div>
      </div>
      <div className="p-grid p-fluid p-justify-center">
        <div className="p-sm-12 p-md-8">
          <Button type="submit" disabled={isSubmitting || !readyToSubmit} label={submitLabel} />
        </div>
      </div>
    </>
  );
};

StandardJobMatchForm.propTypes = {
  formProps: formikFormShape.isRequired,
  jobProfiles: PropTypes.arrayOf(PropTypes.any).isRequired,
  languageList: PropTypes.arrayOf(PropTypes.any).isRequired,
  jobSearching: PropTypes.bool.isRequired,
  readyToSubmit: PropTypes.bool.isRequired,
  searchJob: PropTypes.func.isRequired,
  selectJob: PropTypes.func.isRequired,
  selectLocale: PropTypes.func.isRequired,
};

export default StandardJobMatchForm;
